export class Address {
    country_id: string;
    province_id: string;
    city: string;
    post_code: string;
    street_type_id: string;
    street_name: string;
    street_name2: string;
    street_number: string;
    staircase_number: string;
    floor_number: string;
    apartment_number: string;
    block: string;
    myaddress?: any;
}
